module.exports = __webpack_public_path__ + "static/media/a.a160d89e.png";